// extracted by mini-css-extract-plugin
export default {"footerContainer":"PersonalInstructionsDialog-module__footerContainer--YsPvr"};